import axios, { AxiosRequestConfig } from "axios";
import { APIRoutes, PageRoutes } from "../Utils/constant";
import { toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
export const getUserData = () => {
  const localAuth = localStorage.getItem("auth");
  const decode: any | null = localAuth ? jwtDecode(localAuth || "") : null;
  return decode;
};

const api_url = process.env.REACT_APP_AUTH_URL;
export type authDetailsType = {
  AccessToken: string;
  RefreshToken?: string;
};
export const getCurrentAuth = () => {
  const localAuth = localStorage.getItem("auth");
  const auth: authDetailsType = localAuth
    ? JSON.parse(localStorage.getItem("auth") || "")
    : {};
  return auth;
};

export const Logout = () => {
  localStorage.removeItem("auth");
  localStorage.clear();
  window.location.href = `${PageRoutes.Login}`;
};
const axiosInstance = axios.create();
export function setAuth(data: authDetailsType) {
  const oldAuth = getCurrentAuth();
  const tempAuth = { ...oldAuth, ...data };
  tempAuth.AccessToken = data.AccessToken;
  tempAuth.RefreshToken = data.RefreshToken;

  localStorage.setItem("auth", JSON.stringify(tempAuth));
}

const getIp = async () => {
  try {
    const ip: any = await fetch("https://api.ipify.org?format=json");
    const ip2 = await ip.json();

    return ip2?.ip;
  } catch (error) {
    return "0.0.0.0";
  }
};
const refresh = async () => {
  const auth = getCurrentAuth();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `bearer ${auth.AccessToken}`,
    };
    const response = await axiosInstance.post(
      `${api_url}${APIRoutes.RefreshToken}`,
      {
        refreshToken: auth.RefreshToken,
      },
      { headers: headers }
    );
    if (response.data) {
      const body: any = response.data;
      setAuth({
        AccessToken: body.accessToken,
      });
      return body.accessToken;
    }
  } catch (error: any) {
    // dispatch(logout());

    Logout();
    window.location.href = `${PageRoutes.Login}?user=true`;
  }
};
// var auth = useTypedSelector(getAuthState, shallowEqual);
// const dispatch = useDispatch();
let flag = false;
const refreshExpiredTokenClosure = () => {
  let isCalled = false;
  let runningPromise: any = undefined;
  return () => {
    if (isCalled && flag) {
      return runningPromise;
    } else {
      isCalled = true;
      flag = true;
      runningPromise = refresh();

      return runningPromise;
    }
  };
};

// stores the function returned by refreshExpiredTokenClosure
function shouldRetry(config: any) {
  return config.retries.count < 3;
}
const refreshExpiredToken = refreshExpiredTokenClosure();

axiosInstance.interceptors.request.use(
  // @ts-ignore: Unreachable code error
  (config: AxiosRequestConfig) => {
    const auth = getCurrentAuth();
    if (!config.headers!["Authorization"]) {
      config.headers!["Authorization"] = `bearer ${auth?.AccessToken}`;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },

  async (error) => {
    error.config.retries = error.config.retries || {
      count: 0,
    };
    const originalRequest = error.config;

    // logout user's session if refresh token api responds 401 UNAUTHORIZED

    // if request fails with 401 UNAUTHORIZED status and 'Token has expired' as response message
    // then it calls the api to generate new access token
    // error.response is read with optional chaining throughout: a cancelled
    // request or a network, DNS or CORS failure never gets one, and reading
    // it unconditionally would throw a TypeError inside this handler.
    if (error.response?.status === 401 && shouldRetry(error.config)) {
      error.config.retries.count += 1;
      const updatedToken = await refreshExpiredToken();
      if (!updatedToken) {
        Logout();
        window.location.href = `${PageRoutes.Login}?user=true`;
      } else {
        originalRequest.headers["Authorization"] = `bearer ${updatedToken}`;
        flag = false;
        return axiosInstance(originalRequest);
      }
    } else {
      console.log(error);
      // Callers that show their own inline error and retry (the Audience
      // Layer pages) opt out of this global toast so a failure is not
      // reported twice, and does not keep re-toasting on every poll.
      if (!error.config?.skipGlobalToast) {
        toast.error(error.response?.data?.message || error.response?.data?.error);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
